import PressCacheLogo from "../../../../src/images/services/presscache.svg";
import * as React from 'react';
export default {
  PressCacheLogo,
  React
};